<template>
    <div>
        <div v-if="loading" class="fixed top-0 left-0 right-0 z-[100] h-1 bg-amber-100 overflow-hidden">
            <div class="h-full bg-gradient-to-r from-indigo-500 via-amber-500 to-emerald-500 rounded-full animate-progress"></div>
        </div>
    </div>
</template>
<script>
import { router } from '@inertiajs/vue3';
export default {
    data: () => ({ loading: false }),
    mounted() {
        router.on('start', () => { this.loading = true; });
        router.on('finish', () => { this.loading = false; });
    },
};
</script>
<style scoped>
@keyframes progress {
    0% { width: 0%; margin-left: 0; }
    30% { width: 30%; margin-left: 0; }
    70% { width: 50%; margin-left: 50%; }
    100% { width: 100%; margin-left: 100%; }
}
.animate-progress {
    animation: progress 1.5s ease-in-out infinite;
    width: 30%;
}
</style>
